import { SupportedLanguages } from '@rbi-ctg/frontend';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

import { extractLanguageCode, getLanguageOrDefault } from './language';

export const getLanguageFromQueryString = (queryString: string) =>
  new URLSearchParams(queryString).get('lang');

export const getLanguageFromUserPreferences = () =>
  LocalStorage.getItem<SupportedLanguages>(StorageKeys.LANGUAGE);

export const getNavigatorLanguage = () => {
  const maybeLocale = window?.navigator?.languages?.[0] || window?.navigator?.language || '';

  return extractLanguageCode(maybeLocale);
};

/**
 * Retrieves the language requested by the user.
 *
 * If the requested language is unknown, the market's default language will be returned.
 *
 * @returns Language
 */
export const getRequestedLanguage = () => {
  const languageRequested =
    getLanguageFromQueryString(window.location.search) ||
    getLanguageFromUserPreferences() ||
    getNavigatorLanguage();

  return getLanguageOrDefault(languageRequested);
};
